// Product Status Change-specific validation - Uses generic validation utility
import { createValidation } from '../../utils/validation';

/**
 * Product Status Change-specific validation factory
 * This is a thin wrapper around the generic validation utility
 */
export const createProductStatusChangeValidationSchema = (fields) => {
  const validation = createValidation(fields);
  
  // Return both generic and specific method names for flexibility
  return {
    schema: validation.schema,
    validateData: validation.validateData, // Generic name for configInit
    validateProductStatusChangeData: validation.validateData, // Specific name for backwards compatibility
    validateField: validation.validateField
  };
};

// Default export for backwards compatibility
export default createProductStatusChangeValidationSchema;

